/**
 * Utilities for filtering item attributes based on retailer settings
 */

export interface ItemAttributesConfig {
  displayValueOnly?: (string | null)[] | null;
  displayKeyValue?: (string | null)[] | null;
}

/**
 * Check if a field name is the price field
 * GraphQL sends us 'price' as the field name
 *
 * @param name - Field name to check
 * @returns true if the field is 'price'
 */
const isPriceField = (name?: string): boolean => {
  return name?.toLowerCase() === 'price';
};

export interface ItemDetail {
  name: string;
  value: string;
}

/**
 * Separate price from other attributes
 * @param attributes - Array of item attributes from variant.info
 * @returns Object with price and other details
 */
export const separatePriceFromAttributes = (
  attributes: ItemDetail[] | undefined,
): { price: string | null; details: ItemDetail[] } => {
  if (!attributes || attributes.length === 0) {
    return { price: null, details: [] };
  }

  return attributes.reduce(
    (acc: { price: string | null; details: ItemDetail[] }, cur) => {
      if (isPriceField(cur.name)) {
        acc.price = cur.value;
      } else {
        acc.details.push(cur);
      }
      return acc;
    },
    { price: null, details: [] },
  );
};
